module.exports = __webpack_public_path__ + "img/problem.2098be66.svg";